module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ActivityDetailView.js"));
	}, "ActivityDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ActivityDetailView!./src/pages/Promote/OfflineActivity/ActivityDetail/ActivityDetailView.js
// module id = 2108
// module chunks = 367